import { FunctionComponent } from 'react'
import { ColorsV2TagBackground } from '../../../design-system/colors_v2'
import { useReadVitalCard } from '../../../hooks/queries/vitalCard'
import { getAge } from '../../../misc/date.utilities'
import { MIN_MAJOR_AGE } from '../../../model/Patient'
import { IconButton, Tag } from '../../shared'
import { PatientDetailsPageHeaderProps } from './PatientDetailsPageHeader.model'
import styles from './PatientDetailsPageHeader.module.scss'

export const PatientDetailsPageHeader: FunctionComponent<PatientDetailsPageHeaderProps> = ({
  patient,
  isLoading,
  openPatientInformationsHistory,
}) => {
  const { mutate: readVitalCard } = useReadVitalCard(true)

  const label =
    patient && !!patient.id
      ? `${patient.usedFirstName ?? patient.birthFirstName} ${
          patient.usedLastName ?? patient.birthLastName
        }`
      : 'Nouveau patient'

  return (
    <div className={styles.patientDetailsPageHeaderContainer}>
      <div className={styles.patientDetailsPageHeaderPatientInfos}>
        {!isLoading ? (
          <>
            {label}
            <div className={styles.deceasedAndMinorLabelContainer}>
              {patient?.birthDate && getAge(patient.birthDate) < MIN_MAJOR_AGE && (
                <Tag color={ColorsV2TagBackground.dsTag03} testId="patient_details-minor">
                  Mineur·e
                </Tag>
              )}
              {patient && patient.isDeceased && (
                <Tag color={ColorsV2TagBackground.dsTag09} testId="patient_details-minor">
                  Décédé·e
                </Tag>
              )}
            </div>
          </>
        ) : (
          'Chargement...'
        )}
      </div>
      <div className={styles.patientDetailsPageHeaderActionButtons}>
        {patient && (
          <IconButton
            icon="history"
            size="normal"
            theme="transparent"
            title="Historique informations patient"
            onClick={openPatientInformationsHistory}
            testId="button-patient_details-history-display"
          />
        )}
        <IconButton
          onClick={() => readVitalCard()}
          icon="vitalCardReader"
          size="normal"
          theme="primary"
          testId="button-patient_details-vital_card-read"
        />
      </div>
    </div>
  )
}
